import i18n from '@newspaces/core-app/i18n'

import 'thingfox-base/i18n'

import enLanguage from './languages/en'

i18n.languages = ['en']

i18n.registerLanguage('en', enLanguage)

i18n.setDefaultLocale('en')
i18n.trySetDefaultLocale()

export default i18n
